import type { Container } from 'pixi.js';

export function centerElements(elements: Container[], distance = 10): void {
  const totalWidth = elements.reduce((prev, current) => prev + current.width, 0) + distance * (elements.length - 1);
  let currentX = totalWidth * -0.5;
  elements.forEach((elem) => {
    const elemWidth = elem.width === 0 ? 1 : elem.width;
    elem.x = currentX + ((elem.getLocalBounds().x * -1) / elemWidth) * elemWidth;
    currentX += elemWidth + distance;
  });
}
